// The dashboard's "no value here" marker (#7091), the ONE definition: every
// screen that has no figure for a cell renders this, and every test that proves
// a figure was fetched asserts it is absent BY REFERENCE, never by character.
//
// An ASCII hyphen-minus, not an em dash: the em dash is prose punctuation the
// copy gate refuses (#1407, `copy.dashes.test.ts`), and a hyphen is what the
// console's `zh` bundle already ships for an empty cell (`docs/zh-terms.md`).

/** The unset-value marker. */
export const UNSET = '-';
